/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type NumberPortingStatus =
  (typeof NumberPortingStatus)[keyof typeof NumberPortingStatus];

export const NumberPortingStatus = {
  requested: "requested",
  pending: "pending",
  dateKnown: "dateKnown",
} as const;
